import { Link } from '@evertrue/et-components';
import { PropTypes } from 'base/react-libs';

const ContactSummarySolicitationCodes = ({ solicitationCodes, contactId }) => {
  return (
    <div className="contact-summary--solicitation-code-container">
      {solicitationCodes.slice(0, 2).map((code, index) => (
        <div key={index} className="contact-summary--solicitation-code">
          {code}
        </div>
      ))}
      {solicitationCodes.length > 2 && (
        <Link href={contactId ? `/contact/${contactId}` : '/cadences/'}>+{solicitationCodes.length - 2} more</Link>
      )}
    </div>
  );
};

export default ContactSummarySolicitationCodes;

ContactSummarySolicitationCodes.propTypes = {
  solicitationCodes: PropTypes.array.isRequired,
  contactId: PropTypes.string,
};
